import clsx from 'clsx';
import { FooterConnectForm } from '../FooterConnectForm/FooterConnectForm';
import { useFooterContext } from '../FooterContext';
import FooterSocial from '../FooterSocial/FooterSocial';
import styles from './styles.module.scss';

const FooterConnect = () => {
  const {
    data: {
      isForLanderPage,
      subscribeForm: { title, label }
    }
  } = useFooterContext();

  return (
    <section className={clsx(styles.root, isForLanderPage && styles.isLander)}>
      <div>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.formLabel}>{label}</p>
      </div>
      <FooterConnectForm title={title} />
      <div className={styles.social}>
        <FooterSocial />
      </div>
    </section>
  );
};
export default FooterConnect;
